module.exports = __webpack_public_path__ + "media/img/logos/marktapotheke-eidelstedt-0a5b5b0691c1188b37b11a695700d4e7.png";